export function validateNIM(NIM) {
  if (NIM === '' || Number.isNaN(NIM) || NIM.toString().length !== 8) {
    throw Error('INVALID');
  }
}

export function validatePhone(Phone) {
  if (Phone === '' || Number.isNaN(Phone) || Phone.toString().length > 15) {
    throw new Error('INVALID');
  }
}

export const isImageFromUrl = (url) => {
  const format = `${url.split('.').pop()}`;
  return ['png', 'jpg', 'jpeg'].includes(format);
};

export function validateFileNum(data, maxNum, message) {
  return data.length > maxNum || message;
}

export function validateFileSize(data, maxSize, message, cummulative = false) {
  let cum_size = 0;

  for (let datum of data) {
    if (datum.size > maxSize) {
      return false || message;
    }
    cum_size += datum.size;
  }

  if (cummulative && cum_size > maxSize) {
    return false || message;
  }
  return true;
}

export function validateFileType(data, typeRegEx, message) {
  for (let datum of data) {
    if (!typeRegEx.test(datum.name)) {
      return false || message;
    }
  }

  return true;
}

export function fileValidationFitter(oldRules, acceptedType) {
  let validate = {};
  let rules = {};

  if (oldRules.validateSize) {
    if (oldRules.validateSize.cummulative) {
      const validateSize = (data) =>
        validateFileSize(
          data,
          oldRules.validateSize.value,
          oldRules.validateSize.message,
          oldRules.validateSize.cummulative
        );
      validate = { ...validate, validateSize };
    } else {
      const validateSize = (data) =>
        validateFileSize(
          data,
          oldRules.validateSize.value,
          oldRules.validateSize.message
        );
      validate = { ...validate, validateSize };
    }
  }
  if (oldRules.validateType) {
    let accFileTypes = oldRules.validateType.value;

    if (oldRules.validateType.value === null) {
      if (acceptedType === null) {
        throw new Error(
          'File type validation requesting from null acceptedType'
        );
      } else if (typeof acceptedType !== 'string') {
        throw new Error('acceptedType is not string');
      }
      const tempTypeString = String(acceptedType).replace(/\./g, '');
      const tempTypes = tempTypeString.split(',');
      accFileTypes = tempTypes;
      oldRules.validateType.value = accFileTypes;
    }

    let accFileTypeStr = '\\.(';

    for (let index = 0; index < accFileTypes.length; index++) {
      const element = accFileTypes[index];
      if (index !== 0) {
        accFileTypeStr += '|';
      }
      accFileTypeStr += element;
    }

    accFileTypeStr += ')';

    let typeRegex = new RegExp(accFileTypeStr);

    const validateType = (data) =>
      validateFileType(data, typeRegex, oldRules.validateType.message);

    validate = { ...validate, validateType };
  }
  if (oldRules.validateNum) {
    const validateNum = (data) =>
      validateFileNum(
        data,
        oldRules.validateSize.value,
        oldRules.validateSize.message
      );

    validate = { ...validate, validateNum };
  }

  rules = { ...oldRules, validate };
  return rules;
}
